// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header--B_GY8","content":"Header-module__content--owYJr","heading":"Header-module__heading--hYDeO","subheading":"Header-module__subheading--ulGGx"};